import * as GS from 'styles';

import { useNav } from './Nav.hooks';
import * as S from './Nav.styles';
import { SearchBar } from './components/SearchBar';

export function Nav(): React.ReactElement {
  const { navDataMapped, isSearch, isSearchSet } = useNav();

  return (
    <S.Nav>
      <GS.Inner>
        <S.Wrapper>
          {isSearch ? <SearchBar /> : <S.Ul>{navDataMapped}</S.Ul>}

          <S.SearchButton
            data-testid="search-button"
            iconLeft={isSearch ? 'FiX' : 'FiSearch'}
            onClick={() => isSearchSet(!isSearch)}
          />
        </S.Wrapper>
      </GS.Inner>
    </S.Nav>
  );
}
